import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Instagram, Phone, Mail, MessageCircle } from 'lucide-react';

const Contact = () => {
  const contactMethods = [
    {
      icon: <Instagram size={48} />,
      title: 'Instagram',
      value: '@moonlitpersonalcare',
      link: 'https://instagram.com/moonlitpersonalcare',
      color: 'hsl(345, 60%, 60%)',
      bgColor: 'hsl(345, 60%, 96%)',
      description: 'Follow us for updates and beauty tips'
    },
    {
      icon: <Phone size={48} />,
      title: 'Call Us',
      value: '7307989892',
      link: 'tel:7307989892',
      color: 'hsl(345, 60%, 60%)',
      bgColor: 'hsl(345, 60%, 96%)',
      description: 'Speak directly with our team'
    },
    {
      icon: <Mail size={48} />,
      title: 'Email',
      value: 'info@moonlitpersonalcare.com',
      link: 'mailto:info@moonlitpersonalcare.com',
      color: 'hsl(345, 60%, 60%)',
      bgColor: 'hsl(345, 60%, 96%)',
      description: 'Send us your queries and feedback'
    }
  ];

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'hsl(30, 30%, 98%)' }}>
      <Navigation />

      {/* Hero Section */}
      <section className="relative py-12 sm:py-16 lg:py-20">
        <div className="absolute inset-0 overflow-hidden">
          <img
            src="https://storage.googleapis.com/fenado-ai-farm-public/generated/e29f496a-ea08-4288-b927-470c8218be5b.webp"
            alt="Background"
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(345, 60%, 60%)', lineHeight: 1.4 }}>
            Contact Us
          </h1>
          <p className="text-base sm:text-lg lg:text-xl leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
            We'd love to hear from you. Reach out to us through any of these channels.
          </p>
        </div>
      </section>

      {/* Contact Methods */}
      <section className="py-8 sm:py-12 pb-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            {contactMethods.map((method, index) => (
              <a
                key={index}
                href={method.link}
                target={method.link.startsWith('http') ? '_blank' : undefined}
                rel={method.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                className="bg-white rounded-2xl shadow-sm p-6 sm:p-8 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
              >
                <div className="flex flex-col items-center text-center">
                  {/* Icon */}
                  <div className="p-4 rounded-full mb-4" style={{ backgroundColor: method.bgColor }}>
                    <div style={{ color: method.color }}>
                      {method.icon}
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="text-xl sm:text-2xl font-bold mb-2" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(30, 20%, 20%)' }}>
                    {method.title}
                  </h3>

                  {/* Value */}
                  <p className="text-sm sm:text-base font-semibold mb-3 break-all" style={{ fontFamily: 'Nunito, sans-serif', color: method.color }}>
                    {method.value}
                  </p>

                  {/* Description */}
                  <p className="text-sm leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 10%, 50%)', lineHeight: 1.7 }}>
                    {method.description}
                  </p>
                </div>
              </a>
            ))}
          </div>

          {/* Business Inquiry Section */}
          <div className="mt-12 bg-white rounded-2xl shadow-sm p-6 sm:p-8 lg:p-12">
            <div className="flex items-start gap-4 mb-6">
              <div className="flex-shrink-0 p-3 rounded-lg" style={{ backgroundColor: 'hsl(345, 60%, 96%)' }}>
                <MessageCircle size={32} style={{ color: 'hsl(345, 60%, 60%)' }} />
              </div>
              <div>
                <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-4" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(345, 60%, 60%)' }}>
                  Business Inquiries
                </h2>
                <p className="text-base sm:text-lg leading-relaxed mb-4" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
                  We are looking to connect with strong leaders who wish to develop themselves in their business.
                </p>
                <p className="text-base sm:text-lg leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
                  If you're interested in partnering with us or have business opportunities, please reach out using any of the contact methods above. We'd love to discuss how we can work together to bring Moonlit to every corner of India.
                </p>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-8 text-center">
            <p className="text-sm sm:text-base" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 10%, 50%)', lineHeight: 1.7 }}>
              We typically respond within 24-48 hours. Thank you for your interest in Moonlit!
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
